export default "__VITE_ASSET__e52b228d__"